import React, { useState } from 'react'
import { getData,postData } from '../../global/Globalapi';
const SearchBar1 = ({ placeholder = "Search...", onSearch, className = "" }) => {
    const [query, setQuery] = useState("");
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (onSearch) {
      onSearch(value);
    }
  };
  return (
   <input
      type="text"
      placeholder={placeholder}
      value={query}
      onChange={handleChange}
      className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 text-base ${className}`}
    />
  )
}

export default SearchBar1
